// import color from "../../../constants/color";

import color from "../../../../../constants/color";

const styles = {
  heading:{
    fontSize:"20px",
    fontWeight:"600",
    // pl:2
  },
  TableHead: {
    color: color.lightText,
    fontWeight: "400",

  },
  editIcon: {
    mx: 1,
    display:"flex"
  },
  dltIcon: {
    color: "#fff",
    backgroundColor: color.red,
    p: "3px",
    borderRadius: "50%",
    fontSize: 0
  },
  infoHeading: {
    fontSize: "18px",
    fontWeight: "500"
  },
  infoText: {
    fontSize: "14px",
    fontWeight: "400"
  },

  gridbox: {
    backgroundColor: "#ffff",
    m: 2,
    justifyContent: "space-between",
    py: 2.8,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "175px",

  },
  gridboxes: {
    backgroundColor: "#ffff",
    my: 2,
    mx: {xs:2, md:0},
    justifyContent: "space-between",
    py: 2.8,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "175px",

  },

  gridboxs: {
    backgroundColor: "#ffff",
    m: 2,
    justifyContent: "space-between",
    py: 2.8,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "175px",

  },
  inputSection: {
    px: 2
  },
  companybox: {
    backgroundColor: "#ffff",
    m: 2,
    justifyContent: "space-between",
    py: 2,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },


  tabledata: {
    borderBottom: 0,
  },
  tabledataBorder: {
    borderRadius: "30px", 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    py: "5px", 
    px: "14px", 
    width: "fit-content",
    borderBottom: 0,
    border: "1px solid #28AA4A",
    color: color.primary
  },
  billData: {
    borderRadius: "5px", 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    py: "5px", 
    px: "5px", 
    width: "fit-content",
    borderBottom: 0,
    border: "1px solid #28AA4A",
    color: color.primary
  },

  tableAvtardata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center",
  },

  tableActiondata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center", 
    gap: "20px"
  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text
  },
  deleteIcon: {
    color:"#ff0000"
  },
  input:{
    width:"100%",
    borderRadius: "8px",
    my: 1,
    height: "2.5em",
    marginBottom:"1em"
  },
  space:{
    my:2
  },

  filterText:{
    fontSize:"12px",
    fontWeight:"500",
    mr:"2em"
  },
  width:{
    mr:{xs:0, md:"7px"}
  },
  widths:{
    // mr:{xs:0, md:2}
  },

  containerInput:{
    display: {sx: "block", md:"flex"},
    // flexDirection:"row"
  },
  fromTogrid:{
    display: "flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"space-between"
  },
  statusBtn:
   {border:"1px solid #28AA4A ",
     borderRadius:"10px",
     ml:5,
     mx: {xs: "20px"},
     mt:{xs: "15px", sm: "5px"},
     width: "fit-content",
   },
  name:{
    color:color.text,
    fontSize:"14px",
    fontWeight:"400",
    textTransform:"capitalize"

  },
  mail:{
    color:color.lightText,
    fontSize:"14px",
    fontWeight:"400"
  },  
  row:{
    display:"flex",
    flexDirection:"row",
    justifyContent:"center",
    alignItems:"center",
    pl:4
  },
  checkinBtn:
  { borderRadius: 50, 
    backgroundColor: color.secondary,
    color: "#fff", 
    ml: "8px" ,
    textTransform: "none", 
    fontSize: "12px",
    boxShadow:"none"

  },
  checkoutBtn: {
    borderRadius: 50, 
    backgroundColor: "#28AA4A",
    color: "#fff", 
    ml: "8px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow:"none"
  },
  exportbtn: {
    borderRadius: 50, 
    textTransform: "none" , 
    backgroundColor: color.secondary,
    // mr: "10px", 
    // my: 4,
    alignItems: "center",
    fontSize: "12px",
    px: 3,

  },
  infoValue: {
    fontSize: "14px",
    fontWeight: "600",
    mb:2
  },
  infoValues: {
    fontSize: "14px",
    fontWeight: "600",
  },
  companyBox: {
    mt: 2,
    justifyContent: "space-between"
  },
  companyGrid: {
    alignItems: "center"
  },
  companyGrids: {
    // alignItems: "center"
    textAlign: {xs: "start", md: "start"},
  },

  emailIcon: {
    mr: 1, 
    fontSize:"0px"
  },



};
export default styles;